import { render, staticRenderFns } from "./DownloadOrBuyPanel.vue?vue&type=template&id=7dcca0fb&scoped=true&"
import script from "./DownloadOrBuyPanel.vue?vue&type=script&lang=js&"
export * from "./DownloadOrBuyPanel.vue?vue&type=script&lang=js&"
import style0 from "./DownloadOrBuyPanel.vue?vue&type=style&index=0&id=7dcca0fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcca0fb",
  null
  
)

export default component.exports